var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"scroll-to-top"}},[(_vm.isNotTop)?_c('a',{staticClass:"btn-gotop",on:{"click":_vm.clickToScroll}},[_c('i',{staticClass:"icon icon-arrow-up"}),_c('span',[_vm._v("TOP")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }